<script setup lang="ts">
import { useRouter } from "vue-router";
import { useUserStore } from "@/stores/useUserStore";

const router = useRouter();
const userStore = useUserStore();

const handleGoHome = () => {
	router.push("/");
};

const handleLogin = () => {
	userStore.logout();
	router.push("/login");
};
</script>

<template>
    <section class="flex flex-col items-center gap-6 mt-8 justify-center px-4">
        <div class="flex flex-col items-center text-center gap-4 pb-2">
            <div class="text-8xl mb-4">🔒</div>
            <h1 v-translate class="max-w-3xl text-4xl font-bold">
                Acesso Não Autorizado
            </h1>
            <div class="flex flex-col items-center gap-2">
                <p v-translate class="max-w-2xl text-lg">
                    Você não tem permissão para acessar este recurso.
                </p>
                <p v-translate class="max-w-2xl text-base">
                    Isso pode acontecer se você não estiver autenticado ou se suas permissões foram alteradas.
                </p>
            </div>
        </div>

        <div class="flex flex-col sm:flex-row gap-4 mt-4">
            <Button @click="handleGoHome" variant="default" class="text-lg px-8" v-translate>
                Ir para Página Inicial
            </Button>
            <Button @click="handleLogin" variant="outline" class="text-lg px-8" v-translate>
                Fazer Login Novamente
            </Button>
        </div>
    </section>
</template>
